export default __webpack_public_path__ + "static/media/mobile8.941568bb.jfif";